import { Component } from '@angular/core';
import { HeaderData } from './headerData';
import { TagBreadcrumbs } from './tagBreadcrumbs';
import { AppService } from '../app.service';
import { environment } from '../../environments/environment';
import { AdminService } from '../_services/admin.service';
import { ACLFeature } from '../_models/acl-feature';
import {Permissions} from '../_services/permissions';
import {ActivatedRoute} from '@angular/router';
import Util from '../util';
import { Log } from 'ng2-logger';

const log = Log.create("HeaderComponent");

@Component({
  selector: 'edit-header',
  styleUrls: ['header.less'],
  templateUrl: 'header.component.html',
})
export class HeaderComponent {
  headerData: HeaderData;
  tagBreadcrumbs: TagBreadcrumbs;
  environment;
  environmentMessage: string;
  canReadDrivers = false;
  canWriteDrivers = false;
  canReadModules = false;
  canWriteModules = false;
  canReadBridges = false;
  canWriteBridges = false;
  canReadSensors = false;
  canReadSensorAccessories = false;
  canAccessAdmin = false;
  canManagePortfolio = false;
  canAccessWhitelist = false;
  canAccessSensorWhitelist = false;
  canReadTags = false;
  showArchived = false;
  assumedCompany = null;
  isImpersonating = false;
  impersonatedUser = null;

  constructor(private appService: AppService,
              private permissions: Permissions,
              private admin: AdminService,
              private route: ActivatedRoute) {
    log.info("Constructor");

    this.headerData = appService.headerData;
    this.tagBreadcrumbs = appService.tagBreadcrumbs;
    this.environment = environment;

    this.permissions.hasFeature(ACLFeature.READ_DRIVERS)
      .subscribe((success) => {
        this.canReadDrivers = success;
      });

    this.permissions.hasFeature(ACLFeature.WRITE_DRIVERS)
      .subscribe((success) => {
          this.canWriteDrivers = success;
      });

    this.permissions.hasFeature(ACLFeature.READ_MODULES)
      .subscribe((success) => {
        this.canReadModules = success;
      });

    this.permissions.hasFeature(ACLFeature.WRITE_MODULES)
      .subscribe((success) => {
        this.canWriteModules = success;
      });

    this.permissions.hasFeature(ACLFeature.READ_BRIDGES)
      .subscribe((success) => {
        this.canReadBridges = success;
      });

    this.permissions.hasFeature(ACLFeature.WRITE_BRIDGES)
      .subscribe((success) => {
        this.canWriteBridges = success;
      });

    this.permissions.hasFeature(ACLFeature.READ_SENSORS)
        .subscribe((success) => {
          this.canReadSensors = success;
        });

    this.permissions.hasFeature(ACLFeature.READ_SENSOR_ACCESSORIES)
        .subscribe((success) => {
          this.canReadSensorAccessories = success;
        });

    this.permissions.hasFeature(ACLFeature.ACCESS_SUPER_ADMIN_TAB)
      .subscribe((success) => {
        this.canAccessAdmin = success;
      });

    this.permissions.hasFeature(ACLFeature.READ_SENSORS_WHITELIST)
      .subscribe( (success) => {
        this.canAccessSensorWhitelist = success;
      });

    this.permissions.hasFeature(ACLFeature.READ_TAGS)
      .subscribe( (success) => {
        this.canReadTags = success;
      });

    this.permissions.hasFeature(ACLFeature.WHITELIST_READ)
      .subscribe( (success) => {
        this.canAccessWhitelist = success;
      });

    this.admin.isAssumingRole().subscribe((iAm: boolean) => {
      this.canManagePortfolio = iAm;
    });

    this.admin.getAssumedCompany().subscribe((assumedCompany: object) => {
      this.assumedCompany = assumedCompany;
    });

    this.admin.isImpersonating().subscribe((iAm: boolean) => {
      this.isImpersonating = iAm;
    });

    this.admin.getImpersonatedUser().subscribe((impersonatedUser: object) => {
      console.log('impersonatedUser', impersonatedUser);
      this.impersonatedUser = impersonatedUser;
    });

    this.route.params.subscribe(params => {
      this.showArchived = Util.toBoolean(params['showArchived']);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts